// extracted by mini-css-extract-plugin
export var columnList = "_di-0";